import { KoobContainer } from '@koob/ui';
import React from 'react';

export default function ExperienceLayout({ children }) {
  return (
    <KoobContainer>
      <div className="max-w-6xl mx-auto">{children}</div>
    </KoobContainer>
  );
}
